import React, { useEffect, useState } from 'react';
import { Modal, ModalBody } from 'reactstrap';
import { getHydrantFlushes } from '../../services/api';
import { makeHydrantFlush } from '../../models';
import HydrantFlushTableRow from './HydrantFlushTableRow';

const HydrantFlushModal = ({ hydrantId, open, toggle, onSelect, hydrantFlush }) => {
  const [hydrantFlushes, setHydrantFlushes] = useState([]);

  useEffect(() => {
    setupHydrantFlushes();
  }, [hydrantId, hydrantFlush]);

  const setupHydrantFlushes = async () => {
    const result = await getHydrantFlushes();
    const filtered = result
      .filter((flush) => flush?.hydrantId === hydrantId)
      .sort((a, b) => {
        if (a.startDate < b.startDate) return 1;
        if (a.startDate > b.startDate) return -1;
        return 0;
      })
      .map((flush) => makeHydrantFlush(flush));

    setHydrantFlushes(filtered);
  };

  const select = (id) => {
    toggle();
    onSelect(id);
  };

  const hydrantFlushRows = hydrantFlushes.map((flush) => (
    <HydrantFlushTableRow key={flush.id} flush={flush} onSelect={select} />
  ));

  return (
    <Modal isOpen={open} toggle={toggle}>
      <ModalBody>
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Gallons Used</th>
              <th>Flow Device</th>
              <th></th>
            </tr>
          </thead>
          <tbody>{hydrantFlushRows}</tbody>
        </table>
      </ModalBody>
    </Modal>
  );
};

export default HydrantFlushModal;
